import { Typography, useMediaQuery } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import { ExperienceResource } from '../../../Common/Experience/Types';
import ExperienceLanguageAvailability from '../ExperienceLanguageAvailability';
import Certificate from './Certificate';
import CourseAvailabilityPerWeek from './CourseAvailabilityPerWeek';
import DownloadOverview from './DownloadOverview';
import TotalHour from './TotalHour';
import { getTimeCommitment, getTitleVariant } from './Types';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceOverview({ experienceResource }: Props) {
  const breakPoint = useMediaQuery();
  const timeCommitment = getTimeCommitment(experienceResource.payload);

  return (
    <div
      className="flex flex-col gap-y-4 md:gap-y-6"
      data-intercom-target="experience-overview-section"
    >
      <Typography
        className="text-gray-900"
        variant={getTitleVariant(breakPoint)}
        fontWeight="bold"
        tabIndex={0}
      >
        <T kind="Overview" />
      </Typography>
      <div className="flex flex-wrap gap-x-14 gap-y-5">
        {timeCommitment
          .map(({ totalHours, duration, hoursPerWeek }) => {
            return (
              <div className="flex flex-col gap-y-5">
                <>
                  <CourseAvailabilityPerWeek duration={duration} hoursPerWeek={hoursPerWeek} />
                  <TotalHour totalHours={totalHours} />
                </>
                <Certificate experienceResource={experienceResource} />
              </div>
            );
          })
          .getOrElse(() => (
            <Certificate experienceResource={experienceResource} />
          ))}
        <div className="flex flex-col gap-y-5">
          <DownloadOverview experienceResource={experienceResource} />
          <ExperienceLanguageAvailability
            experience={experienceResource.payload}
            className="text-gray-600"
          />
        </div>
      </div>
    </div>
  );
}
export default observer(ExperienceOverview);
